import type { FC, PropsWithChildren } from 'react';

import { ImageComponent } from '@/components/Image';
import { ScContainer } from '@/styles/common';
import { ScBottomDecor } from './styled';

export const BottomSection: FC<PropsWithChildren> = ({ children }) => (
  <ScBottomDecor>
    <ImageComponent
      alt="popcorn"
      className="popcorn left"
      height={270}
      loading="lazy"
      src="/scratchGame/popcorn-bottom-item.webp"
      width={270}
    />
    <ImageComponent
      alt="popcorn"
      className="popcorn right"
      height={270}
      loading="lazy"
      src="/scratchGame/popcorn-bottom-item.webp"
      width={270}
    />
    <ScContainer>{children}</ScContainer>
  </ScBottomDecor>
);
